
import state from './../../../../../zviz2/zviz/state';
import {default as Group, Controller as GroupController} from './../../../../../zviz2/zviz/components/group';
import Rectangle from './../../../../../zviz2/zviz/components/rectangle';

import TextBox from './../../../../../zviz2/zviz/components/svg/textbox';
import Arc from './../../../../../zviz2/zviz/components/arc';

import {extend, executeCallback} from './../../../../../zviz2/zviz/functions';
import {styleText} from './../../../../../styles';



class Controller extends GroupController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);



        this.maxSize = 35;
        
    }

    render(renderer){
        if(this.hasChanged){
            if(this.isHovered()){
                let e = this.renderOutput.result;
                if(e.parentNode.lastChild != e){
                    e.parentNode.appendChild(e);
                }
            }
        }
        super.render(renderer);
    }

    restoreOrder(){
        // perhaps better to set the order at the parent..?
        if(this.renderOutput && this.renderOutput.result){
            let e = this.renderOutput.result;
            for(let i = this.parent.children.length-1; i >= 0; i--){
                if(this.parent.children[i].data.item.size <= this.data.item.size){
                    e.parentNode.insertBefore(e, this.parent.children[i].renderOutput.result);
                    break;
                }
            }
        }
    }

    getScale(getSize=false){
        return 1;
    }

    getBubbleType(){
        if(this.data && this.data.notOnMap){
            return 'circle';
        }
        return (this.getScale() > 0.7)? 'pin': 'circle';
    }


    isHovered(){
        let hover = state.get('map.itemHover');
        if(hover){
            let dim = hover[0];
            let value = hover[1];
            
            if(this.data && this.data.item && dim == this.data.item.type && value == this.data.item.name){
                return true;
            }else if(this.data.item.type == 'region' && dim == 'id3' && this.data.item.countries.indexOf(value) != -1){
                return true;
            }
        }
        return false;
    }

    getOpacity(){
        let hover = state.get('map.itemHover');
        if(hover && hover[0] == this.data.item.type){
            return (hover[1] == this.data.item.value)? 1: 0.5;
        }else if(this.data.item.type == 'region' && hover[0] == 'id3'){
            return (this.data.countries.indexOf(hover[1]) > -1);
        }
        return 0.98;
    }

    getColor(){
        return this.data.item.color;
    }

    getInfo(){

        let result = [];

        let ctrl = this.getByUid(this.data.parentUid);
        let doShow = ctrl.showInfoBox(this.uid);

        let o = this.getOpacity();
        if(o == 1 || (o != 0.5 && doShow)){
            let dy = 0;
            let props = {
                properties: {
                    data: {
                        alignment: this.data.align,
                        dy: dy,
                        isOnMap: this.data.notOnMap,
                        opacity: o,
                        type: this.data.item.type,
                        name: this.data.item.name
                    }
                }
            };
            // result.push(extend(props, BlueprintInfo)); // rectangle

            let title = this.data.item.name;
            if(title == 'great_lakes_region'){
                title = 'Great Lakes region';
            }else if(title == 'horn_of_africa'){
                title = 'Horn of Africa';
            }
            if(this.getByUid('svgMap').data.language == 'dutch'){
                if(title == 'Great Lakes region'){
                    title = 'Grote Merengebied';
                }else if(title == 'Ethiopia'){
                    title = 'Ethiopië';
                }else if(title == 'Democratic Republic of the Congo'){
                    title = 'Democratische Republiek Congo';
                }else if(title == 'Uganda'){
                    title = 'Oeganda';
                }else if(title == 'Horn of Africa'){
                    title = 'Hoorn van Afrika';
                }else if(title == 'Sudan'){
                    title = 'Soedan';
                }else if(title == 'South Sudan'){
                    title = 'Zuid-Soedan';
                }else if(title == 'Somalia'){
                    title = 'Somalië';
                }else if(title == 'Uganda'){
                    title = 'Oeganda';
                }else if(title == 'Indonesia'){
                    title = 'Indonesië';
                }else if(title == 'Kenya'){
                    title = 'Kenia';
                }else if(title == 'Palestinian Territories'){
                    title = 'Palestijnse Gebieden';
                }else if(title == 'Yemen'){
                    title = 'Jemen';
                }
            }
            
            result.push(extend({
                properties: {
                    data: {
                        text: title || '- empty value -',
                        dy: dy,
                        alignment: this.data.align,
                        width: 200,
                    }
                }
            }, BlueprintLine1));

        }

        return result;
    }

    setHover(value, timeout=0){

        // if(globals.mapHoverTimerId) clearTimeout(globals.mapHoverTimerId);
        // globals.mapHoverTimerId = null;

        // if(timeout>0){
        //     let ctrl = this;
        //     globals.mapHoverTimerId = setTimeout(function(){
        //         state.set('map.itemHover', value);
        //         if(! value){
        //             ctrl.restoreOrder(); 
        //         }
        //     }, timeout);
        // }else{
            state.set('map.itemHover', value);
            if(! value){
                this.restoreOrder(); 
            }
        // }

    }

    canZoom(){
        let f = state.get('filter.' + this.data.item.type);
        return (! f);
    }

} 


let Blueprint = {
    type: Controller,
    properties: { 
        style: { 
            cursor: (ctrl) => ( ctrl.canZoom()? 'pointer': 'default')  
        },
        data: {
            align: 'left',
            item: {},
            coords: [0, 0],
            countries: [],
            notOnMap: false,
            parentUid: '',
            onClick: false,
            projectIcon: true
        }
    },
    listeners: [
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.update], 'map.itemHover') )
    ],
    children: [
        (parent) => (extend({
            type: GroupController,
            properties: { 
                transform: {
                    position: {
                        x: parent.data.coords[0],
                        y: parent.data.coords[1]
                    }
                }
              },
            children: parent.getInfo()
        }, Group)),

        (parent) => (extend({
            properties: {
                style: {
                    fill: parent.data.item.type == 'id3'? 'rgb(255,255,255)': 'transparent',
                    stroke: parent.data.item.type == 'id3'? 'rgb(202, 0, 93)': 'white',
                    strokeWidth: parent.data.item.type == 'id3'? '1px': '2px',
                    fillOpacity: parent.getOpacity()
                },
                attributes: {
                    'r':  parent.data.item.type == 'id3'? '6px': '13px',
                    'cx': parent.data.coords[0],
                    'cy': parent.data.coords[1]
                }
            }
        }, Arc) )
            
    ],

    events: {
        click: (event, ctrl) => { 
            let t = Date.now() - ctrl.getByUid('map').panTime;
            if(t < 500){ 
                return; 
            }
            let val = {type: ctrl.data.item.type, value: ctrl.data.item.value};
            state.set('map.countryHighlight', val);
        },
        mouseover: (event, ctrl) => { ctrl.setHover([ctrl.data.item.type, ctrl.data.item.value] ); },
        mouseout: (event, ctrl) => { ctrl.setHover(null, 300) },
    }
};

let BlueprintInfo = extend({
    properties: {
        attributes: {
            'x': (ctrl) => (ctrl.data.alignment == 'left'? 0: -230),
            'y': (ctrl) => (ctrl.data.dy)-20,
            'width': 230,
            'height': 40
        },
        style: {
            fill: (ctrl) => (ctrl.data.isOnMap? 'rgb(225,225,225)': 'rgb(255,255,255)'),
            fillOpacity: (ctrl) => ( ctrl.data.opacity == 1? 0.4: 0.4)
        },
        data: {
            alignment: 'left',
            dy: 0,
            opacity: 1,
            isOnMap: true
        }
    }
}, Rectangle);



let BlueprintLine1 = extend({
    properties: {
        style: extend({
            fill: 'black',
            fontSize: '18px',
        }, styleText),
        transform: {
            position: {
                x: (ctrl) => (ctrl.data.alignment == 'right'? -215: 15),
                y: 5
            }
        },
        data: {
            text: 'Item',
            height: 40,
            dy: 0,
            alignment: 'left',
            scale : 1,
            width: 200,
            //verticalAlign: 'middle',
            lineHeight: 20
        }
    },
    
}, TextBox);

let BlueprintLine2 = extend({
    properties: {
        style: extend({
            fontSize: '12px',
            fill: '#444'
        }, styleText),
        transform: {
            position: {
                x: (ctrl) => ( ctrl.data.alignment == 'right'? -142: ctrl.data.scale + 10 ),
                y: (ctrl) => ( (ctrl.parent.children[1] && ctrl.parent.children[1].textHeight)? ctrl.data.dy + 0.5 * ctrl.parent.children[1].textHeight + 28: ctrl.data.dy + 35 )
            }
        },
        data: {
            text: '',
            height: 35,
            dy: 0,
            lineHeight: 12,
            alignment: 'left',
            width: 150,
        }
    }
}, TextBox);


export default Blueprint;
export {Controller, Blueprint};

